import React from 'react';
import { CompletedContainersTable } from '../components/CompletedContainersTable';
import { VesselDeparturesWidget } from '../components/VesselDeparturesWidget';
import { PortTransitTimesWidget } from '../components/PortTransitTimesWidget';
import { CurrentPricesWidget } from '../components/CurrentPricesWidget';
import { LatestOfferTable } from '../components/LatestOfferTable';

interface Layout4Props {
  completedContainers: any[];
  vesselDepartures: any[];
  portTransitTimes: any[];
  currentPrices: any[];
  latestOffer: any;
}

export const Layout4Hybrid: React.FC<Layout4Props> = ({
  completedContainers,
  vesselDepartures,
  portTransitTimes,
  currentPrices,
  latestOffer,
}) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 auto-rows-min">
        <div className="md:col-span-2 xl:col-span-1 flex">
          <VesselDeparturesWidget portsDepartures={vesselDepartures} maxRows={6} />
        </div>

        <div className="md:col-span-2 xl:col-span-1 flex">
          <CurrentPricesWidget prices={currentPrices} maxRows={6} />
        </div>

        <div className="md:col-span-2 xl:col-span-1 flex">
          <LatestOfferTable offer={latestOffer} maxRows={3} />
        </div>

        <div className="md:col-span-2 xl:col-span-2 flex">
          <CompletedContainersTable containers={completedContainers} />
        </div>

        <div className="md:col-span-2 xl:col-span-3">
          <PortTransitTimesWidget transitTimes={portTransitTimes} maxItems={4} />
        </div>
      </div>
    </div>
  );
};
